'use strict';

export default class ModelsListCtrl {
  static get UID() {
    return 'modelsListCtrl';
  }

  constructor($stateParams, modelFac, $location){
    'ngInject';
    Object.assign(this, { $stateParams, modelFac, $location });

    this.models = [];
    this.currentPage = parseInt($stateParams.pageNum, 10) || 1;
    this.rowcount = 6;
    this.order = $stateParams.order || 'weight';
    this.reverseOrder = true;

    this.modelFac.getModels()
      .then((response) => {
        this.models = response.data.data;
      });

  }

  orderRecent() {
    this.order = 'recent';
    this.reverseOrder = true;
    this.currentPage = 1;
  }

  orderAlpha() {
    this.order = 'alpha';
    this.reverseOrder = false;
    this.currentPage = 1;
  }

  ordering() {
    let orderBy;

    switch (this.order) {
      case 'alpha' :
        orderBy = 'name';
        break;
      case 'recent' : 
        orderBy = 'latestUpdateDate';
        break;
      case 'weight' :
      default:
        orderBy = 'weight';
        break;
    }

    return orderBy;
  };
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/modelsList/modelsListCtrl.js